
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/linear/document-text","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#0079f2","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M2 10v5c0 5 2 7 7 7h6c5 0 7-2 7-7V9c0-5-2-7-7-7h-5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M2 10h4c3 0 4-1 4-4V2zM17 13h-6M17 17h-4"}})])])
          )
        }
      }
    